import { Component } from '@angular/core';

@Component({
  selector: 'app-home',
  imports: [],
  providers: [],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss'
})
export class HomeComponent  {

}
